// ** MUI Imports
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

interface Props {
  nama: string
  jabatan: string
  foto: string
}

const CustomProfileCard = (props: Props) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
      <Avatar src={props.foto} alt={props.nama} sx={{ width: 150, height: 150, mb: 2 }} />
      <Typography variant='body1' textAlign='center' fontWeight={600} color={theme => theme.palette.primary.main} letterSpacing={0}>
        {props.nama}
      </Typography>
      <Typography variant='body2' textAlign='center' letterSpacing={0}>
        {props.jabatan}
      </Typography>
    </Box>
  )
}

export default CustomProfileCard
